import getTaskInfo from '../taskModule/taskInfo'
import getInvestigateTaskInfo from '../investigateModule/taskInfo'
import getOtherInvestigateTaskInfo from '../otherInvestigateModule/taskInfo'
import getMediateTaskInfo from '../mediateModule/taskInfo'
import getLawsuitTaskInfo from '../lawsuitModule/taskInfo'

export default function() {
	if (this.isInvestigate) {
		return getInvestigateTaskInfo.call(this)
	} else if (this.isOtherInvestigate) {
		return getOtherInvestigateTaskInfo.call(this)
	} else if (this.isMediate) {
		return getMediateTaskInfo.call(this)
	} else if (this.isLawsuit) {
		return getLawsuitTaskInfo.call(this)
	} else {
		return getTaskInfo.call(this)
	}
}
